import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

export function DeltaBadge({ value, suffix = "%", invert = false, className }) {
  if (value === null || value === undefined) return null;
  const zero = value === 0;
  const good = invert ? value < 0 : value > 0;
  const Icon = zero ? Minus : value > 0 ? ArrowUpRight : ArrowDownRight;
  const color = zero
    ? "text-muted-foreground"
    : good
    ? "text-[hsl(var(--success))]"
    : "text-destructive";
  return (
    <span
      data-testid="delta-badge"
      className={cn("inline-flex items-center gap-1 font-num text-xs font-medium", color, className)}
    >
      <Icon className="h-3 w-3" />
      {value > 0 ? "+" : ""}
      {value.toFixed(1)}
      {suffix}
    </span>
  );
}
